<template>
	<div class="insightBox">
		<div class="leftChildNav" :class="showLeft ? '' : 'hide'">

	<!-- <el-menu :default-active="activeMenu" active-text-color="#fff" router class="el-menu-vertical-demo"
				@close="handleClose">
				<el-submenu v-for="(item, index) in route[activeR]" :key="index" :index="item.title">
					<template slot="title">
						<img :src="item.icon" style="margin-right: 16px; width: 22px;" alt="">
						<span>{{ item.title }}</span>
					</template>
					<el-menu-item v-for="(item1, index1) in item.children" :index="item1.path" :key="index1">{{ item1.title
					}}</el-menu-item>
				</el-submenu>
			</el-menu> -->
			<el-menu :default-active="activeMenu" active-text-color="#fff" router class="el-menu-vertical-demo">
				<el-menu-item class="noParentItem" index="/home" v-if="showHome">
					<img src="@/assets/image/cIcon5.png" style="margin-right: 15px; width: 20px;" alt="">
					首页
				</el-menu-item>
				<el-submenu v-for="(item, index) in route[activeP]" :key="index" :index="item.resourceName">
					<template slot="title">
						<img :src="item.icon" style="margin-right: 20px;" alt="">
						<span class="menu-label">
							{{ item.resourceName }}
							<span class="menu-badge" v-if="getNum(item.resourceName) > 0">{{ getNum(item.resourceName) }}</span>
						</span>
					</template>
					<el-menu-item v-for="(item1, index1) in item.children" :index="item1.resourceUrl" :key="index1">{{
						item1.resourceName
					}}
						<span class="menu-badge" v-if="getSumNum(item1) > 0">{{ getSumNum(item1) }}</span>
					</el-menu-item>
				</el-submenu>
				<el-submenu>
					<template slot="title">
						<img src="@/assets/image/center1.png" style="margin-right: 16px; width: 22px;" alt="">
						<span class="menu-label">
							个人中心
						</span>
					</template>
					<el-menu-item index="/PersonalCenter/MyAccount">我的
					</el-menu-item>
				</el-submenu>
			</el-menu>
		</div>
		<div class="rightContent">

			<!-- <div class="openNav backNav" style="top: 68px;" @click="goBack">
				<i class="el-icon-s-fold " style="font-size: 20px; color: #999;" v-if="showLeft"></i>
<span v-if="showLeft"> 返回上一页</span>
			</div>
			<div class="closeNav backNav" style="top:  68px;" @click="goBack">

				<i class="el-icon-s-fold " style="font-size: 20px; color: #999;" v-if="!showLeft"></i>
				<span v-if="!showLeft"> 返回上一页</span>
			</div> -->
			<img class="openNav" v-if="showLeft" src="../assets/image/shouqi.png" @click="changeState({
				prop: 'showLeft',
				value: false
			})" />
			<img class="closeNav" v-if="!showLeft" @click="changeState({
				prop: 'showLeft',
				value: true
			})" src="../assets/image/zhankai.png" />
			<router-view />
		</div>
	</div>
</template>

<script>
import { getLocalAppConfig } from "@/utils/appConfig";
import { getUnreadCountSingle, getUnreadCountBatch, currentUser } from '@/api/public'

import {
	getDetail
} from "@/api/MyAccount";
import {
	mapState,
	mapMutations
} from 'vuex'
export default {
	name: 'home',
	data() {
		return {
			SingleNum: 0,
			BatchNum: 0,
			routerChildren: [],
			activeP: 'Pledge',
			activeR: 'PersonalCenter',
			title: {
				PersonalCenter: '个人中心',
			},
			route: {
				PersonalCenter: [{
					path: '/PersonalCenter/MyAccount',
					title: '个人中心',
						icon: require('../assets/image/center1.png'),

					children: [
						{
							path: '/PersonalCenter/MyAccount',
							title: '我的'
						},
					],
				},

				],
				Pledge: [

				],
				Analysis: [{
					path: '/Empowerment/Analysis/Home',
					icon: 'iconfont icon-shouye',
					title: '首页'
				},

				],
			}
		};
	},
	computed: {
		...mapState(['showLeft', "fixedLeft"]),
		activeMenu() {
			// let route = this.$route;
			// let path = route.path;
			// // let activeMenu = this.route(this.activeR);
			// return path;
			let route = this.$route;
			let path = route.path;
			let meta = route.meta;
			if (meta && meta.from) {
				path = meta.from;
			}
			// let activeMenu = this.route(this.activeR);
			return path;
		},
		userId() {
			return this.$store.state.userId;
		},
		showHome() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return true;
			}
			if (cachedConfig.homePage === 'true') {
				return true
			} else {
				return false
			}
		},
	},
	async mounted() {
		// let data = await getDetail(this.userId)
		// if (data.userType == 1) {
		// }
		this.getRouterList();
		this.getUnreadCountNum();
	},
	methods: {
		...mapMutations(['changeState', "changeFixed"]),
		async getRouterList() {
			let routerList = [
				{
					path: '',
					title: '单套',
					icon: require('../assets/image/dantao.png'),
					children: [

						{
							path: '/Empowerment/pledge/houseProperty/rapidValuation',
							title: '我要估价'
						},
						{
							path: '/Empowerment/pledge/houseProperty/recordValuation',
							title: '历史记录'
						},
					]
				},

				{
					path: '',
					title: '批量',
					icon: require('../assets/image/piliang.png'),

					children: [
						{
							path: '/Empowerment/pledge/pledgeManage/taskManageNew',
							title: '我要估价'
						},
						{
							path: '/Empowerment/pledge/pledgeManage/taskRecord',
							title: '历史记录'
						},
					]
				}
			]
			routerList.unshift(				
				{
				path: '/Empowerment/Analysis/Home',
				title: '首页',
				icon: require('../assets/image/dantao.png'),
			})
			// routerList = res.menu.find(item => item.resourceName === 'AI估价');
			let menuList = localStorage.getItem('menuList') ? JSON.parse(localStorage.getItem('menuList')) : [];
			const aiValuation = menuList.find(item => item.resourceName === 'AI估价');
			if (aiValuation && Array.isArray(aiValuation.children)) {
				routerList = aiValuation.children;
			}
			if (routerList && Array.isArray(routerList)) {
				routerList.sort((a, b) => {
					return (a.sort || 0) - (b.sort || 0);
				});
			}
			function filterTypeOne(list) {
				return (list || []).reduce((acc, item) => {
					if (item.type === '1') {
						const newItem = { ...item };
						if (Array.isArray(item.children)) {
							newItem.children = filterTypeOne(item.children);
						}
						acc.push(newItem);
					} else if (Array.isArray(item.children)) {
						// 如果当前节点type不是1，但是有children可能有type为1的子节点
						const filteredChildren = filterTypeOne(item.children);
						if (filteredChildren.length) {
							const newItem = { ...item, children: filteredChildren };
							acc.push(newItem);
						}
					}
					return acc;
				}, []);
			}
			routerList = filterTypeOne(routerList);
			this.route.Pledge = routerList;
			console.log('this.$router', this.$router.getRoutes())
		},
		selectRouter(data) {
			if (this.$route.path === data) return;
			if (data.indexOf('noPage') > -1) {
				return
			}
			this.$router.push(data).catch(err => err);
		},
		subMenuClick(arr) {
			if (arr.length) {
				const data = arr.pop().replace('submenu', '')
				data && this.$router.push(data);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		getNum(title) {
			// return 1;
			if (title == '单套') {
				return this.SingleNum;
			} else if (title == '批量') {
				return this.BatchNum;
			}
		},
		getSumNum(item) {
			// return 200;
			if (item.resourceName == '历史记录' && item.resourceUrl == '/Empowerment/pledge/houseProperty/recordValuation') {
				return this.SingleNum;
			} else if (item.resourceName == '我要估价' && item.resourceUrl == '/Empowerment/pledge/pledgeManage/taskManageNew') {
				return this.BatchNum;
			}
		},
		getUnreadCountNum() {
			// :0-单 1-任务批量
			let params = {
				// type: 0,

			}
			let params1 = {
				// type: 1,

			}
			getUnreadCountSingle(params).then(res => {
				console.log('res单套数量', res)
				this.SingleNum = res;
			})
			getUnreadCountBatch(params1).then(res => {
				console.log('res任务批量数量', res)
				this.BatchNum = res;
			})
		},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .el-menu-item.is-active {
	// color: #fff;
	background: #045AFC;
	width: 90%;
	margin: auto;
	text-align: center;
	border-radius: 8px;

}

::v-deep .el-menu-item:focus,
.el-menu-item:hover {
	// background: #045AFC;
	width: 90%;
	margin: auto;
	border-radius: 8px;


}

::v-deep .el-menu-item {
	transform: none !important;
	text-align: center;
	-webkit-transition: none !important;
	/* 兼容旧版浏览器 */
}

@import "@/style/common.scss";

.backNav {
	width: 100px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px !important;
	span {
		font-size: 14px;
		color: #999;
	}
}
.noParentItem {
text-align: left; width: 100% !important; border-radius: none !important;
}
::v-deep .el-menu-item .menu-badge {
	position: absolute;
	// right: 14px;
	margin-left: -6px;
	top: 30%;
	left: auto;
	transform: translateY(-50%);
}
.menu-badge {
	position: absolute;
	// left: 64%;
	top: 10px;
	transform: translateX(6px);

	display: inline-flex;
	align-items: center;
	justify-content: center;

	min-width: 18px;
	height: 18px;
	padding: 0 6px;
	border-radius: 999px;

	background: #F56C6C;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	line-height: 18px;
	white-space: nowrap;
}
</style>
